import { useContext, useEffect } from 'react'
import { OrbitRegistryContext } from './orbitRegistryContext'
import type { OrbitPageDescriptor } from './orbitTypes'

export const useOrbit = (descriptor: OrbitPageDescriptor) => {
  const registry = useContext(OrbitRegistryContext)
  const registerDescriptor = registry?.registerDescriptor
  const setDescriptor = registry?.setDescriptor

  useEffect(() => {
    if (registerDescriptor) {
      return registerDescriptor(descriptor)
    }
    setDescriptor?.(descriptor)
    return () => {
      setDescriptor?.(null)
    }
  }, [descriptor, registerDescriptor, setDescriptor])

  return registry
}
